export const labelStyle = {
  width: '100%',
  color: 'var(--petrol-color)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '4px',
  boxSizing: 'border-box',
};

export const errorStyle = {
  border: '1px solid red',
  color: 'red',
};

export const inputStyle = {
  width: '100%',
  padding: '8px 10px',
  outline: '0',
  border: '1px solid var(--border-color)',
  fontSize: '16px',
  borderRadius: '4px',
  boxSizing: 'border-box',
};
